import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LinkAccountCarousel from './LinkAccountCarousel';
import { getLinkAccountPage } from '../../../modules/content/selectors';
import { open } from '../../../modules/modal/actions';
import backupContent from '../../../../resources/linkAccountBackup.json';

const LinkAccount = ({ content, openLoginModal }) => {
  let linkAccountContent;
  if (content) {
    linkAccountContent = content;
  } else {
    linkAccountContent = backupContent;
  }
  const { image: { src }, cta: { text: buttonText }, features } = linkAccountContent;
  const carouselSpeedInSeconds = 5;

  return (
    <div className="link-account" data-test-id="link-account">
      <div className="container--fixed link-account__background">
        <img className="link-account__image" src={src} />
        <button
          className="link-account-button"
          dangerouslySetInnerHTML={{ __html: buttonText }}
          onClick={openLoginModal}
          type="button"
        />
        <LinkAccountCarousel features={features} duration={carouselSpeedInSeconds} />
      </div>
    </div>
  );
};

LinkAccount.propTypes = {
  content: PropTypes.object,
  openLoginModal: PropTypes.func
};

const mapDispatchToProps = {
  openLoginModal: open.bind(null, {
    componentName: 'LinkAccountTerms',
    componentProps: {
      contentToDisplay: 'login'
    }
  })
};

const mapStateToProps = (state) => ({
  content: getLinkAccountPage(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(LinkAccount);
